// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: '',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  auth: {
    idPlatform: 'Apk01',
    user: 'MaltiaMovil',
    password: 'lkjhklKJHGKJHGKJHKJH543218HGVBHY78##2020',
  },
  s3_bucket: 'maltia',
  s3_region: 'us-east-2',
  s3_accessKey: 'AKIAJKXVNC776Y4CWDYQ',
  s3_secretKey: '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',
  s3_IdentityPoolId: 'us-east-2:d46ade67-9d15-4e97-9ec1-820059bd974d',
  urlAPI: 'https://admin.maltia.cleversecdesarrollo.app:5700/API/v1.0/',
  // urlAPI: 'https://localhost:44380/API/v1.0/',
  keyCP: 'f872f772-c463-462c-ba73-b1a1dab3b6b3',
  appName: 'Administrador Maltia',
  google: {
    mapsApiKey: 'AIzaSyCmV1UJRDHKX1_UeaRrAIeCh7SeBxyNVzM',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
